import {CheatPlugin} from '../../CheatModuleInterfaces';
import {CheatSessionController} from './CheatSessionController';
import {CheatSessionView} from './CheatSessionView';

const session: CheatPlugin = {
    name: 'Session',
    init: () => [
        CheatSessionController,
        CheatSessionView
    ]
};

export default session;
